(function ($) {
    $(window).scroll(function () {

		$('header').toggleClass('is-sticky', $(document).scrollTop() > 210);

        if ($(document).scrollTop() > 210) { 
            $('.logo-link img').attr('src','/wp-content/themes/oztrekk/assets/images/OzTrekk-logo.png');
        }
    });


})(jQuery);
